import { isAdmin, hasPermission } from '@/utils/auth'
import {
  buildBreadcrumbNameMap,
  buildNavigationMenu,
  NavigationMenuItem,
} from '@/navigation/menuModel'

import type { MenuItemType, SubMenuType } from 'antd/es/menu/hooks/useItems'

function getNavigationMenus (): NavigationMenuItem[] {
  return buildNavigationMenu({
    isAdmin: isAdmin(),
    hasPermission,
  })
}

function toMenuItems (items: NavigationMenuItem[]): MenuItemType[] {
  return items.map(({ key, label, icon, children }) => ({
    key,
    label,
    icon,
    ...(children ? { children: toMenuItems(children) } : {}),
  })) as MenuItemType[]
}

const getMenus = () => toMenuItems(getNavigationMenus())

const menus = getMenus()

const breadcrumbNameMap: Record<string, string> = buildBreadcrumbNameMap(getNavigationMenus())

export type { MenuItemType, SubMenuType }

export {
  menus,
  getMenus,
  breadcrumbNameMap,
}
